import React from "react";

const Dnf = ({ message = "No data found" }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center py-5"
      style={{ minHeight: "300px" }}
    >
      <i
        className="ri-database-2-line"
        style={{
          fontSize: "60px",
          color: "#adb5bd",
        }}
      />

      <h6 className="mt-3 mb-1">{message}</h6>

      <small className="text-muted">
        There is nothing to display right now.
      </small>
    </div>
  );
};

export default Dnf;
